import React from "react";

const OdometerTableLoadable = React.lazy(() => import("./OdometerTable"));

export { OdometerTableLoadable };